/**
 * localStorage/sessionStorage erişimi; gizli sekme, kota veya kapalı
 * depolamada bellek içi yedeğe düşer, hiçbir zaman hata fırlatmaz.
 */

type Area = "local" | "session";

const memory: Record<Area, Map<string, string>> = {
  local: new Map(),
  session: new Map(),
};

function getStorage(area: Area): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    const storage = area === "local" ? window.localStorage : window.sessionStorage;
    const probe = "__sc_probe__";
    storage.setItem(probe, "1");
    storage.removeItem(probe);
    return storage;
  } catch {
    return null;
  }
}

export function readJson<T>(area: Area, key: string, fallback: T): T {
  let raw: string | null | undefined;
  const storage = getStorage(area);
  try {
    raw = storage ? storage.getItem(key) : memory[area].get(key);
  } catch {
    raw = memory[area].get(key);
  }
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? { ...fallback, ...parsed } : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(area: Area, key: string, value: unknown) {
  const raw = JSON.stringify(value);
  memory[area].set(key, raw);
  const storage = getStorage(area);
  if (!storage) return;
  try {
    storage.setItem(key, raw);
  } catch {
    // Bellek içi kopya yeterli.
  }
}

export function removeKey(area: Area, key: string) {
  memory[area].delete(key);
  const storage = getStorage(area);
  try {
    storage?.removeItem(key);
  } catch {
    // yok say
  }
}
